<template>
    <div class="project-creating-container container">
        <div class="project-creating-form">
            <div class="title">{{$t("project.createProject")}}</div>
            <project-form :editData="{}"></project-form>
        </div>
        <div class="back-home"><router-link to="/projectlist"><i class="el-icon-back icon-btn"></i></router-link></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectForm from '../CmpProjectForm/CmpProjectForm';
export default {
    name: "ProjectCreating",
    // 修改新增项目 inject报错
    provide() {
        return {
            handleEdit: {}
        }
    },
    computed: {
        // 项目列表
        ...mapGetters(["user"])
    },
    mounted() {
        if(this.user.usertype >= 4) {
            this.$notify({
                title: '警告',
                message: '暂无操作权限',
                type: 'warning',
                duration: 1500,
                onClose: () => {
                    this.$router.push('/projectlist')
                }
            });
        }
    },
    components: {
        ProjectForm
    },
};
</script>

<style scoped>
.project-creating-container {
    padding: 24px;
    background: #fff;
    position: relative;
}
.project-creating-container .title {
    margin-bottom: 24px;
    text-align: center;
    font-size: 20px;
}
.project-creating-form {
    width: 500px;
    margin: auto;
    /* padding: 24px 32px; */
}

.back-home{
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 20px;
}

</style>
